export const name = 'mnz_ai_rmvbgrnd';
